import React from 'react';
import propTypes from 'prop-types';
import PaymentForm from './PaymentForm';

const StripeContainer = (props) => {
    const {
        buttonIsDisabled,
        onPayButtonSubmit,
        buttonLabel,
        buttonStyle,
        buttonHeight,
        buttonWidth,
    } = props;
    return (
        <PaymentForm
            buttonIsDisabled={buttonIsDisabled}
            buttonLabel={buttonLabel}
            buttonStyle={buttonStyle}
            buttonHeight={buttonHeight}
            buttonWidth={buttonWidth}
            onPayButtonSubmit={onPayButtonSubmit}
        />
    );
};

StripeContainer.propTypes = {
    buttonIsDisabled: propTypes.bool,
    onPayButtonSubmit: propTypes.func,
    buttonLabel: propTypes.node,
    buttonStyle: propTypes.shape({}),
    buttonHeight: propTypes.string,
    buttonWidth: propTypes.string,
};

StripeContainer.defaultProps = {
    buttonIsDisabled: false,
    onPayButtonSubmit: () => {},
    buttonLabel: <div />,
    buttonStyle: {},
};
export default StripeContainer;
